import { useCallback, useEffect } from 'react';

function useKeyDown(keys, active, callback) {
    var handleKeyDown = useCallback(function(e) {
        var requestedKeys = Array.isArray(keys) ? keys : [
            keys
        ];
        if (requestedKeys.includes(e.key)) {
            callback(e);
        }
    }, [
        callback,
        keys
    ]);
    useEffect(function() {
        if (active) {
            document.addEventListener("keydown", handleKeyDown);
        } else {
            document.removeEventListener("keydown", handleKeyDown);
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        active,
        handleKeyDown
    ]);
}

export { useKeyDown };
